import ButtonV2 from '@jobseeker/lotus/elements/ButtonV2';
import Radio from '@jobseeker/lotus/elements/Radio';
import {
  Box,
  Typography,
  styled,
  TextField as BaseTextField,
  RadioGroup,
} from '@mui/material';
import {useState} from 'react';
import {UNSUBSCRIBE_COLLECTION_INFO} from '../../constants';

const TextField = styled(BaseTextField)(({theme}) => ({
  'textarea::placeholder': {
    fontStyle: 'italic',
  },
  '.MuiInputBase-root': {
    fontSize: 12,
    padding: theme.spacing(1),
    borderRadius: theme.spacing(1),
  },
  fieldset: {
    borderColor: '#7E7E7E33',
  },
  '.Mui-focused': {
    '&.Mui-focused fieldset': {
      borderColor: '#333',
      border: '1px solid',
    },
  },
}));

type CollectionFormInfo = {
  handleGoBack: () => void;
  handleCallback: (formValue: string, otherComment: string) => void;
};

const CollectionForm = ({handleGoBack, handleCallback}: CollectionFormInfo) => {
  const isAppIimjobs = process.env.NEXT_PUBLIC_APP_NAME === 'iimjobs';

  const [formValue, setFormValue] = useState('');
  const [otherComment, setOtherComment] = useState('');
  const [error, setError] = useState('');

  const handleConfirm = () => {
    handleCallback(formValue, otherComment);
  };
  return (
    <Box width={'100%'} px={2} pt={isAppIimjobs ? 5 : 3} pb={3}>
      <Typography variant="subtitle1">
        {`We’re sorry to see you go, please tell us your reason for unsubscribing`}
      </Typography>
      <Typography
        component={'p'}
        variant={'subtitle3'}
        color={'text.secondary'}
        sx={{
          mt: 0.5,
        }}
      >{`To help us improve our services, we would be grateful if you could tell us reason :`}</Typography>

      <RadioGroup
        sx={{ml: 0.25, mt: 1.5}}
        onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
          setFormValue((event.target as HTMLInputElement).value);
        }}
      >
        {UNSUBSCRIBE_COLLECTION_INFO.map((info, index) => (
          <Radio
            key={`radio-unsubscribe-collection-${index}`}
            sx={{py: 0}}
            size={24}
            name={info?.key}
            value={info?.type}
            label={<Typography variant="body2">{info?.title}</Typography>}
            formSx={{
              mt: index > 0 ? 2.75 : 1.25,
              mb: info?.key === 'other' ? 1.25 : 0,
            }}
          />
        ))}
        {formValue == '6' && (
          <TextField
            name={'other_comment'}
            value={otherComment}
            multiline
            maxRows={4}
            inputProps={{}}
            rows={4}
            placeholder="Add your comments here"
            variant="outlined"
            onChange={event => {
              const value = (event.target as HTMLInputElement).value?.trim();
              if (value.length > 256) {
                setError('Text more than 256 characters not allowed!');
              } else {
                setError('');
                setOtherComment((event.target as HTMLInputElement).value);
              }
            }}
            error={!!error}
            helperText={error}
          />
        )}
      </RadioGroup>

      <Box display={'flex'} gap={2} mt={3} flexWrap={'wrap'}>
        <ButtonV2
          onClick={() => {
            handleConfirm();
          }}
          variant="contained"
          disabled={formValue == '6' ? !otherComment : !formValue}
          sx={{
            width: {xxs: '100%', md: 'fit-content'},
            background: '#000',
            ...(!isAppIimjobs && {
              background: 'primary',
              color: 'primary',
              borderRadius: '3px',
            }),
          }}
        >
          Unsubscribe
        </ButtonV2>
        <ButtonV2
          onClick={handleGoBack}
          variant="outlined"
          sx={{
            width: {xxs: '100%', md: 'fit-content'},
            borderColor: 'primary',
            ...(!isAppIimjobs && {
              background: 'primary',
              color: 'primary',
              borderRadius: '3px',
            }),
          }}
          color="primary"
        >
          Go Back
        </ButtonV2>
      </Box>
    </Box>
  );
};

export default CollectionForm;
